import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import appConstants from "../constants/appConstants";

const ChangePassword = () => {
  const navigate = useNavigate();
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    const userData = localStorage.getItem("userData");
    if (!userData) {
      navigate("/login");
      return;
    }

    const parsedData = JSON.parse(userData);
    if (parsedData.type.toLowerCase() !== "staff") {
      navigate("/login");
    }
  }, [navigate]);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (loading || isSubmitted) return; // Prevent multiple submissions

    setError("");
    setSuccess("");

    if (newPassword !== confirmPassword) {
      setError("New passwords do not match!");
      return;
    }

    setLoading(true);
    setIsSubmitted(true);
    const authToken = localStorage.getItem("authToken");

    try {
      const response = await fetch(`${appConstants.API_ROOT_URL}change-staff-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({
          old_password: oldPassword,
          new_password: newPassword,
        }),
      });

      const data = await response.json();
      setLoading(false);

      if (response.ok) {
        setSuccess("Password changed successfully!");
        setTimeout(() => {
          setIsSubmitted(false);
          navigate("/dashboard");
        }, 2000);
      } else {
        setError(data.message || "Failed to change password.");
        setIsSubmitted(false);
      }
    } catch (err) {
      setLoading(false);
      setError("Network error. Please try again.");
      setIsSubmitted(false);
    }
  };

  return (
    <Layout>
      <div className="text-center">
        <h2>Change Password</h2>
      </div>
      <div className="card p-4" style={{ maxWidth: "400px", margin: "auto" }}>
        {error && <div className="alert alert-danger">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}
        <form onSubmit={handleChangePassword}>
          <div className="mb-3">
            <label>Old Password</label>
            <input type="password" className="form-control" value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} required disabled={loading} />
          </div>
          <div className="mb-3">
            <label>New Password</label>
            <input type="password" className="form-control" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required disabled={loading} />
          </div>
          <div className="mb-3">
            <label>Confirm New Password</label>
            <input type="password" className="form-control" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required disabled={loading} />
          </div>
          <button type="submit" className="btn btn-primary w-100" disabled={loading || isSubmitted}>
            {loading ? "Changing..." : "Change Password"}
          </button>
        </form>
      </div>
    </Layout>
  );
};

export default ChangePassword;
